export default {
    inquiry:{
        title: {
            text: 'Inquiry on PA',
            id: 'MEDCAL_RX_INQUIRY_TITLE'
        }
    },
    upload:{
        title: {
            text: 'Upload PA Attachments',
            id: 'MEDCAL_RX_UPLOAD_TITLE'
        }
    },
    cancel:{
        title: {
            text: 'Cancel PA',
            id: 'MEDCAL_RX_CANCEL_TITLE'
        }
    },
    update:{
        title: {
            text: 'Add Additional Information',
            id: 'MEDCAL_RX_UPDATE_TITLE'
        }
    },
    providerNPILabel: {
        id: 'MEDCAL_RX_PROVIDER_NPI_LABEL',
        defaultMessage: 'Provider NPI:',
    },
    providerNPIValue: {
        id: 'MEDCAL_RX_PROVIDER_NPI_VALUE',
    },
    authorizationNumberLabel: {
        id: 'MEDCAL_RX_AUTHORIZATION_NUMBER_LABEL',
        defaultMessage: 'Authorization Number:',
    },
    authorizationNumberValue: {
        id: 'MEDCAL_RX_AUTHORIZATION_NUMBER_VALUE',
        defaultMessage: 'Authorization Number'
    },
    invalidInputDataMessage: {
        id: 'MEDCAL_RX_INVALID_INPUT_DATA',
        defaultMessage: 'Invalid Input Data',
    },
    apiError:{
        getMessage: code => `System encounter an error. Please try again later.`
    },
    universalVerbiage: 'Please allow up to 24 hours for Prior Authorization requests to be processed before results may be visible.'
}